import { render, staticRenderFns } from "./DQVehicleCustomisationComponent.vue?vue&type=template&id=aecd2b6c"
import script from "./DQVehicleCustomisationComponent.vue?vue&type=script&lang=ts"
export * from "./DQVehicleCustomisationComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports